import { Injectable } from '@angular/core'
import { from } from 'rxjs'
import { NotificationService } from './notification.service'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { PATH } from '../app.api'

@Injectable()
export class HelperService {
	constructor(private http: HttpClient) {}

		public keyIpAddress = 'xWb7!1s$yT58'
		private keyDecrypt = 'KEY_DECRYPT_ARBOLINK'
		private alreadyConnectedInWebsocket: boolean
		private websocket: any
		private ipAddress: string
		private firstRender: boolean = true


	public validateToken() {
		const options: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')

		return this.http.get<any>(`${PATH}/auth/validate-token`, { headers: options })
	}

		private subModuleForRoutes: {
				[key: string]: Array<string>
		} = {
				'central-control/dashboard': [
						'DASHBOARD'
				],
				'central-control/public-panel': [
						'PUBLIC_PANEL'
				],
				'realtimeLocation': [
						'REAL_TIME'
				],
				'user': [
						'USER'
				],
				'companyServiceProvider': [
						'COMPANY_SERVICE_PROVIDER'
				],
				'inventory/schedulerInventory': [
						'INVENTORY_SCHEDULE'
				],
				'inventory/pre-schedule': [
						'INVENTORY_SCHEDULE'
				],
				'inventory/historyInventory': [
						'INVENTORY_HISTORY'
				],
				'protected/inventoryReportArboreal/:inventoryIds': [
						'INVENTORY_REPORT'
				],
				'protected/plantingOpportunityReportArboreal/:plantingsOpportunityIds': [
						'PLANTING_REPORT'
				],
				'protected/plantingReportArboreal/:plantingIds': [
						'PLANTING_REPORT'
				],
				'planting/scheduler-planting': [
						'PLANTING_SCHEDULE'
				],
				'planting-operation/operation': [
						'PLANTING_SCHEDULE'
				],
				'planting/history-planting': [
						'PLANTING_HISTORY'
				],
				'appraisal/scheduler': [
						'APPRAISAL_SCHEDULE'
				],
				'appraisal/demandsHistory': [
						'APPRAISAL_HISTORY'
				],
				'protected/evaluationReportArboreal/:appraisalIds': [
						'APPRAISAL_REPORT'
				],
				'protected/communicationAppraisal/:appraisalIds': [
						'APPRAISAL_HISTORY'
				],
				'appraisal/evaluation/steps': [
						'APPRAISAL_SCHEDULE'
				],
				'operation/schedule': [
						'OPERATION_SERVICE_SCHEDULE'
				],
				'management/operationService': [
						'OPERATION_SERVICE_SCHEDULE'
				],
				'management/operationHistory': [
						'OPERATION_SERVICE_HISTORY'
				],
				'protected/operationReportArboreal': [
						'OPERATION_SERVICE_REPORT'
				],
				'protected/operationServiceScheduleReportArboreal/:operationsId': [
						'OPERATION_SERVICE_REPORT'
				],
				'tree': [
						'TREE'
				],
				'managementConfiguration': [
						'MANAGEMENT_CONFIGURATION'
				],
				'evaluations': [
						'APPRAISAL_CONFIGURATION'
				],
				'operations': [
						'OPERATION_FIELD'
				],
				'admin': [
						'ADMIN_ARBOLINK'
				],
				'company': [
						'CLIENT'
				],
				'botanic': [
						'BOTANICAL_KEY'
				],
				'species': [
						'SPECIE'
				],
				'regions': [
						'REGION'
				],
				'operation/pre-schedule': [
						'OPERATION_SERVICE_SCHEDULE'
				]
		}

		public routesForSubModules = {
				DASHBOARD: 'central-control/dashboard',
				REAL_TIME: 'realtimeLocation',
				USER: 'user',
				COMPANY_SERVICE_PROVIDER: 'companyServiceProvider',
				REGION: 'regions',
				INVENTORY_SCHEDULE: 'inventory/schedulerInventory',
				INVENTORY_HISTORY: 'inventory/historyInventory',
				PLANTING_SCHEDULE: 'planting/scheduler-planting',
				PLANTING_HISTORY: 'planting/history-planting',
				APPRAISAL_SCHEDULE: 'appraisal/scheduler',
				APPRAISAL_HISTORY: 'appraisal/demandsHistory',
				APPRAISAL_CONFIGURATION: 'evaluations',
				OPERATION_SERVICE_SCHEDULE: 'management/operationService',
				OPERATION_SERVICE_HISTORY: 'management/operationHistory',
				PUBLIC_PANEL: 'central-control/public-panel',
				MANAGEMENT_CONFIGURATION: 'operations',
				OPERATION_FIELD: 'managementConfiguration',
				ADMIN_ARBOLINK: 'admin',
				CLIENT: 'company',
				REQUESTER: 'requester',
				BOTANICAL_KEY: 'botanic',
				SPECIE: 'species'
		}

		public getSubModulesForRoutes(route: string): Array<string> {
				return this.subModuleForRoutes[route] || []
		}

		public getRoutesForSubModules(subModule: string): string {
				return this.routesForSubModules[subModule]
		}

		public getBotanicRoutes(): Array<string> {
				const botanicKeys = ['BOTANICAL_KEY', 'SPECIE']

				const routes = []

				botanicKeys.forEach(key => {
						routes.push(this.getRoutesForSubModules(key))
				})

				return routes
		}

		public validateBotanicRoutes(actualRoute: string): boolean {
				return this.getBotanicRoutes().includes(actualRoute) || this.getPublicRoutes().includes(actualRoute)
		}

		public getPublicRoutes() {
				return [
						'#',
						'panel',
						'redirect',
						'login',
						'remember-password',
						'reset-password',
						'logout',
						'userDetail',
						'privacy'
				]
		}

		public isFirstRender(): boolean {
				return this.firstRender
		}

		public setFirstRender(value: boolean): void {
				this.firstRender = value
		}

		public getAlreadyConnectedInWebsocket(): boolean {
				return this.alreadyConnectedInWebsocket
		}

		public setAlreadyConnectedInWebsocket(value: boolean): void {
				this.alreadyConnectedInWebsocket = value
		}

		public getWebsocket(): any {
				return this.websocket
		}

		public setWebsocket(value: any): void {
				this.websocket = value
		}

		public setIpAddress(ip: string): void {
				const ipCriptografado = this.encrypt(ip)
				localStorage.setItem(this.keyIpAddress, ipCriptografado)
				this.ipAddress = ip
		}

		public getUserIp(): string {
				if (this.ipAddress) {
						return this.ipAddress
				} else {
						const ip = localStorage.getItem(this.keyIpAddress)
						if (ip) {
								return this.decrypt(ip)
						}

						return null
				}
		}

		public setUserIp() {
				this.getIpAddress().then((ipAddress: string) => {
						this.setIpAddress(ipAddress)
				})
		}

		public async getIpAddress() {
				const apis = [
						'https://api.ipify.org/?format=json',
						'https://api.bigdatacloud.net/data/client-ip',
						'https://api.myip.com/',
						'https://api-bdc.net/data/client-ip'
				]

				for (const api of apis) {
						try {
								const response = await fetch(api)

								if (!response.ok) {
										throw new Error(`Response not OK ${response.status}`)
								}

								const data = await response.json()

								return data.ip || data.ipString || data.clientIp
						} catch (error) {
								console.error(`Error getting IP address from ${api}:`, error)
						}
				}

				throw new Error('All APIs failed to return the IP address')
		}

		public clearLocalStorage() {
				localStorage.clear()
				localStorage.setItem('acceptTerms', 'true')
				this.setUserIp()
		}

		private encrypt(message: string) {
				let result = ''
				for (let i = 0; i < message.length; i++) {
						const charCode = message.charCodeAt(i) ^ this.keyDecrypt.charCodeAt(i % this.keyDecrypt.length)
						result += String.fromCharCode(charCode)
				}
				return result
		}

		private decrypt(message: string) {
				let result = ''
				for (let i = 0; i < message.length; i++) {
						const charCode = message.charCodeAt(i) ^ this.keyDecrypt.charCodeAt(i % this.keyDecrypt.length)
						result += String.fromCharCode(charCode)
				}
				return result
		}
}
